import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EColors2 } from 'libs/styles/styling';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    palcement?: 'left' | 'right';
    text: string;
}

export const GuideHint = (props: Props): JSX.Element => {
    return (
        <S_GuideHint className={props.className}>
            <Tooltip
                placement={props.palcement ?? 'right'}
                trigger={['click']}
                overlay={<S_Text>{props.text}</S_Text>}
            >
                <S_Icon icon={['fas', 'info-circle']} />
            </Tooltip>
        </S_GuideHint>
    );
};

const S_GuideHint = styled.div``;

const S_Icon = styled(FontAwesomeIcon)`
    width: 15px;
    height: 15px;
    color: ${EColors2.DARK};
    margin-left: 5px;
    cursor: pointer;
`;

const S_Text = styled.div``;
